<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <template v-for="(item, index) in items">
                <template v-if="item.to">
                    <li v-class="getItemClasses(item)" v-bind="getItemAttrs(item)">
                        <router-link :to="item.to" :title="item.title" v-bind="getItemLinkAttrs(item)">
                            {{ item.title }}
                        </router-link>
                    </li>
                </template>
                <template v-else>
                    <li v-class="getItemClasses(item)" v-bind="getItemAttrs(item)" aria-current="page">{{ item.title }}</b></li>
                </template>
            </template>
        </ol>
    </nav>
</template>
<script>
export default {
    name: 'oc-breadcrumb',
    props: {
        items: {
            type: Array
        }
    },
    methods: {
        getItemClasses(item) {
            let isActive = item.to === undefined
            if( item.active !== undefined ) {
                isActive = item.active
            }

            return [
                'breadcrumb-item',
                {
                    active: isActive
                }
            ]
        },
        getItemAttrs(item) {
            return item.attrs || {}
        },
        getItemLinkAttrs(item) {
            return item.linkAttrs || {}
        }
    }
}
</script>
